import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import Illustration from "../../assets/images/illustration-2.png";
import { fetchContentCollection } from "../../behavior/api/content";
import { PageRoute } from "../../constants";
import { ArticleCardList } from "../common";
import { Button, Heading, HorizontalLine, Image } from "../elements";

const LearnWithHubert = () => {
    const { t } = useTranslation();
    const { data: contentData, isLoading: loading } = useQuery({
        queryKey: ["contentCollection", { limit: 4, page: 1 }],
        queryFn: fetchContentCollection({
            tags: [],
            optionalTags: [],
            limit: 4,
            page: 1,
        }),
    });

    return (
        <div className="learn-with-hubert-wrapper">
            <Heading level="h1">{t("Dashboard.LearnWithHubert.Title")}</Heading>
            <Heading level="h4" light>
                {t("Dashboard.LearnWithHubert.Subtitle")}
            </Heading>
            <Image src={Illustration} alt="Illustration" className="illustration" />
            <div className="content-wrapper">
                <div className="title-section">
                    <Heading level="h5">{t("Dashboard.LearnWithHubert.PickedForMe")}</Heading>
                    <Button
                        size="small"
                        secondary
                        link
                        to={PageRoute.LEARN_WITH_HUBERT}
                        ariaLabel={t("Dashboard.LearnWithHubert.ButtonText_SeeAllArticles")}
                    >
                        <div>{t("Dashboard.LearnWithHubert.ButtonText_SeeAllArticles")}</div>
                        <ArrowRight size={20} className="ms-1.5 rtl:-scale-x-100" />
                    </Button>
                </div>
                <HorizontalLine weight="semi-dark" />
                <ArticleCardList articles={contentData?.contents} loading={loading || !contentData} />
            </div>
        </div>
    );
};

export default LearnWithHubert;
